/*
 * YipYip — product details slots
 * ---------------------------------------------------------------------------
 * One job: close the slots on a phone.
 *
 * yy-product-details.liquid ships every `<details>` with `open` in the HTML so
 * the copy is readable with no JavaScript and to a crawler, and CSS pins them
 * open above 750px because up there they are cards, not an accordion. The
 * comp's phone drawing shows three CLOSED rows with a `+`, and three expanded
 * descriptions would push the rest of the page a screen and a half down, so
 * below 750px the `open` attribute is dropped here.
 *
 * Only rows the visitor has not touched are re-synced on a resize: once
 * someone has opened or closed a row deliberately, rotating the phone must not
 * undo it.
 */
(function () {
  'use strict';

  var DESKTOP = window.matchMedia('(min-width: 750px)');

  function sync() {
    document.querySelectorAll('.yy-pd__slot').forEach(function (slot) {
      if (slot.dataset.yyTouched === 'true') return;
      slot.open = DESKTOP.matches;
    });
  }

  function init() {
    var slots = document.querySelectorAll('.yy-pd__slot');
    if (!slots.length) return;

    slots.forEach(function (slot) {
      // `toggle` fires for programmatic changes too, so the flag is set from
      // the summary's own click rather than from the state change.
      var summary = slot.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', function () {
          slot.dataset.yyTouched = 'true';
        });
      }
    });

    sync();
    DESKTOP.addEventListener('change', sync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
